import type { ListingLocaleOverrides } from '../base';

export const KYOverrides: ListingLocaleOverrides = {
  locale: 'KY',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            county: {
              validation: () => [],
            },
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellerCard: {
          fields: {
            powerOfAttorneyFirstName: {
              label: 'Authorized Signer First Name',
            },
            powerOfAttorneyLastName: {
              label: 'Authorized Signer Last Name',
            },
          },
        },
      },
    },
    buyerSideContacts: {
      cards: {
        buyerCard: {
          fields: {
            powerOfAttorneyFirstName: {
              label: 'Authorized Signer First Name',
            },
            powerOfAttorneyLastName: {
              label: 'Authorized Signer Last Name',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: {
          hideByDefault: false,
        },
      },
    },
  },
};
